import React from "react";
import HEADER from "../header/Header.component";
import FOOTER from "../footer/Footer.component";
import { IBaseLayoutProps } from "./Layout.types";
import LayoutStyles from "./Layout.styles";

const BASE_LAYOUT: React.FC<IBaseLayoutProps> = (props: IBaseLayoutProps) => {
  return (
    <>
      <HEADER />
      <LayoutStyles.GridContainer className="grid-container" fluid="xl">
        {props.children}
      </LayoutStyles.GridContainer>
      <FOOTER />
    </>
  );
};
export default BASE_LAYOUT;
